<template>
    <div class="d-flex flex-column width-max-content">
        <div v-if="date">
            <!-- eslint-disable vue/no-custom-modifiers-on-v-model -->
            <vc-date-picker
                ref="datePicker"
                v-model.string="date"
                :attributes="attributes"
                :masks="{modelValue: 'YYYY-MM-DD'}"
                :locale="$i18n.locale"
                :columns="isMobile ? 1 : 2"
                mode="date"
                is-required
                @did-move="pageChange"
                @dayclick="onDayClick"
            />
        </div>
        <v-progress-linear v-if="loading" indeterminate />
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class EventsCalendar extends Vue {
        @Prop() groups
        @Prop() loading

        date = null

        async mounted() {
            this.date = this.$dateFns.format(new Date(), 'yyyy-MM-dd')

            await this.$nextTick()

            const year = this.$refs.datePicker?.dateParts[0].year
            const month = this.$refs.datePicker?.dateParts[0].month
            const startDate = new Date(+year, +month - 1, 1)
            let endDate = this.$dateFns.addMonths(new Date(+year, +month - 1, 0), 2)
            if (this.isMobile) endDate = new Date(+year, +month, 0)

            await this.onPageChange(startDate, endDate)
        }

        @Emit()
        async onPageChange(startDate, endDate) {
            return {startDate, endDate}
        }

        @Emit()
        async onDayClick(day) {
            return day
        }

        async pageChange(dates) {
            const startYear = dates[0]?.monthComps.year
            const startMonth = dates[0]?.monthComps.month
            const endYear = dates[this.isMobile ? 0 : 1]?.monthComps.year
            const endMonth = dates[this.isMobile ? 0 : 1]?.monthComps.month
            const endDay = dates[this.isMobile ? 0 : 1]?.monthComps.numDays

            const startDate = new Date(+startYear, +startMonth - 1, 1)
            const endDate = new Date(+endYear, +endMonth - 1, endDay)

            await this.onPageChange(startDate, endDate)
        }

        get attributes() {
            return this.groups.reduce((attributes, group) => {
                const filteredGroups = this.groups?.filter(
                    g => g.dateTime.split(' ')[0] === group.dateTime.split(' ')[0]
                )

                attributes.push({
                    dates: this.$dateFns.format(group.dateTime),
                    key: group.dateTime,
                    highlight:
                        filteredGroups?.length && filteredGroups.every(g => g.status === 'DONE') ? 'green' : 'yellow',
                })

                return attributes
            }, [])
        }

        get firstDayOfWeekByLocale() {
            return this.$dateFns.localeOptions[this.$i18n.locale].weekStartsOn
        }

        get personId() {
            return authStore.person.personId
        }

        get isGuide() {
            return authStore.isGuide
        }

        get isDriver() {
            return authStore.isDriver
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default EventsCalendar
</script>

<style lang="scss" scoped>
    :deep(.v-date-picker-table__events) {
        width: 100%;
        height: 100%;
        z-index: -1;
        bottom: 1px;
        left: -2px;

        div {
            width: 100%;
            height: 100%;
        }
    }
</style>
